import cache from "_cacheModule";
import minmaxUtils from "_src/engine/utility/minmax";

export default class {

  constructor(cacheID, hasSelected, chunkID = "", chunkBbox = []) {

    this.cacheID = cacheID;
    this.chunkID = chunkID;
    this.chunkBbox = [];
    minmaxUtils.copy(this.chunkBbox, chunkBbox);
    this.cacheInfo = [];
    this.hasSelected = hasSelected;

  }

  apply(chunk) {

    chunk.geometry.setHasSelectedVertices(this.hasSelected);
    minmaxUtils.copy(chunk.geometry.bbox, this.chunkBbox);

    return loadCachedData(chunk, this.cacheInfo);

  }

  appendData(chunk, buffersNames) {

    const geometry = chunk.geometry;
    const layout = geometry.getLayout();

    for (let bufferName of buffersNames) {
      if (bufferName in layout) {
        const buffer = layout[bufferName].getBuffer();
        const bufferType = layout[bufferName].type;
        this._putIntoCache( buffer, bufferType, bufferName );
      }
    }

  }

  clearCache() {

    for (let info of this.cacheInfo) {
      const id = info.id;
      cache.delete(id);
    }

  }

  checkCacheEntry(bufferName) {

    for (let info of this.cacheInfo) {
      if (info.name === bufferName) {
        return true;
      }
    }

    return false;

  }

  updateCache(chunk) {

    const geometry = chunk.geometry;
    const oldCacheInfo = this.cacheInfo;

    this.cacheInfo = [];

    const layout = geometry.getLayout();

    for (let oldInfo of oldCacheInfo) {

      const bufferName = oldInfo.name;

      if (bufferName in layout) {
        const buffer = layout[bufferName].getBuffer();
        const bufferType = layout[bufferName].type;
        this._putIntoCache( buffer, bufferType, bufferName );
      }

    }

  }

  _putIntoCache( data, buffType, name ) {

    const id = this.cacheID + name;

    if (!hasId(this.cacheInfo, id)) {
      this.cacheInfo.push( { id, name, buffType } );
      cache.put(id, data);
    }

  }

  removeFromCache(buffName) {
    const id = this.cacheID + buffName;
    for (let i=0; i<this.cacheInfo.length;) {
      if (this.cacheInfo[i].id === id) {
        cache.delete(id);
        this.cacheInfo.splice(i, 1);
      } else {
        i++;
      }
    }
  }

}

function hasId(cacheInfo, id) {

  for (let info of cacheInfo) {
    if (info.id === id) {
      return true;
    }
  }

  return false;

}

function loadCachedData(chunk, cacheInfo) {

  const geometry = chunk.geometry;
  const promises = [];

  for (let info of cacheInfo) {

    const id = info.id;
    const bufferName = info.name;
    const bufferType = info.buffType;
    const item = geometry.getLayoutItem(bufferName);
    promises.push(
      cache.extract(id).then((buffer) => {
        item.setBuffer(buffer, bufferType);
      })
    );

  }

  return Promise.all(promises).then(() => {

    for (let info of cacheInfo) {
      chunk.markAttributeDirty(info.name);
    }

    geometry.repairSelectionBuffers();

  });

}
